import { applyPolyfills, defineCustomElements } from "@autosync/ats-components/loader";

/**
 * Automatically register all Fusion web components.
 */
export default defineNuxtPlugin(() => {
  if (typeof window !== "undefined") {
    applyPolyfills().then(() => {
      defineCustomElements(window);
    });
  }
});
